export type Purchase = {
  name: string
  location: string
}

export const purchases: Purchase[] = [
  { name: 'Dra. Camila Restrepo', location: 'Medellín, Colombia' },
  { name: 'Dr. Javier Fuentes', location: 'Santiago, Chile' },
  { name: 'Dra. Lucía Herrera', location: 'Guadalajara, México' },
  { name: 'Dr. Martín Aguirre', location: 'Córdoba, Argentina' },
  { name: 'Dra. Paola Vargas', location: 'Quito, Ecuador' },
  { name: 'Dr. Esteban Ríos', location: 'Lima, Perú' },
  { name: 'Dra. Andrea Salazar', location: 'San José, Costa Rica' },
  { name: 'Dr. Rodrigo Peña', location: 'Montevideo, Uruguay' },
  { name: 'Dra. Gabriela Mendoza', location: 'Caracas, Venezuela' },
  { name: 'Dr. Luis Bermúdez', location: 'Ciudad de Panamá, Panamá' },
  { name: 'Dra. Elena Navarro', location: 'Sevilla, España' },
  { name: 'Dr. Óscar Domínguez', location: 'Asunción, Paraguay' },
  { name: 'Dra. Fernanda Cabrera', location: 'La Paz, Bolivia' },
  { name: 'Dr. Iván Castillo', location: 'Santo Domingo, Rep. Dominicana' },
  { name: 'Dra. Rosa Quintana', location: 'Guatemala, Guatemala' },
]
